var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/nsips-doctor-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-41381b50!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/nsips-doctor-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/NsipsDoctorList.vue
// module id = 328
// module chunks = 1